import { create } from '@thoughtspot/logger';
import { LATEST_CLIENT_STATE_SCHEMA as CHART_LATEST_CLIENT_STATE_SCHEMA } from './chart-client-state/upgrader';
import { LATEST_CLIENT_STATE_SCHEMA as TABLE_LATEST_CLIENT_STATE_SCHEMA } from './table-client-state/upgrader';
import { ChartType } from './types/prism';
export const logger = create('client-state-util');
function isClientStateValid(clientState) {
    let clientStateSchema;
    if (clientState.__typename === 'ChartVizProps') {
        clientStateSchema = CHART_LATEST_CLIENT_STATE_SCHEMA;
    }
    else if (clientState.__typename === 'TableVizProps') {
        clientStateSchema = TABLE_LATEST_CLIENT_STATE_SCHEMA;
    }
    else {
        return true;
    }
    const { error } = clientStateSchema.validate(clientState);
    if (error) {
        logger.warn(error);
        return false;
    }
    return true;
}
export const tsHostedCustomCharts = [
    ChartType.AdvancedPivotTable,
    ChartType.MuzeStudio,
    ChartType.AdvancedColumn,
    ChartType.AdvancedStackedColumn,
    ChartType.AdvancedBar,
    ChartType.AdvancedStackedBar,
    ChartType.AdvancedLine,
    ChartType.AdvancedArea,
    ChartType.AdvancedStackedArea,
    ChartType.AdvancedLineColumn,
    ChartType.AdvancedLineStackedColumn,
    ChartType.AdvancedDonut,
    ChartType.AdvancedScatter,
    ChartType.AdvancedBubble,
    ChartType.AdvancedWaterfall,
    ChartType.AdvancedHeatmap,
    ChartType.AdvancedPareto
];
export const isCustomChart = (chartType) => {
    return chartType === ChartType.CustomChart;
};
export const isTsHostedChart = (chartType) => {
    return tsHostedCustomCharts.includes(chartType);
};
export const isCustomOrTsHostedChart = (chartType) => {
    return isCustomChart(chartType) || isTsHostedChart(chartType);
};
export { isClientStateValid };
//# sourceMappingURL=utils.js.map